export default __webpack_public_path__ + "static/b_helles_05-720d381498108c02c45e9ea41538aea5.png";